import { Typography, TypographyProps } from '@mui/material';

export default function ErrorText(props: Omit<TypographyProps, 'color'>) {
    return <Typography color="error" {...props} />;
}
